import React from 'react';

function Tagline(props) {
  return <span className='tagline'>{props.tags}</span>;
}

export default Tagline;
